import Styles from '../../../1.manual/3.school/2.edit/styles.module.css';
import React, { useEffect } from 'react';
import { useState } from 'react';
import DefaultInput1 from '../../../../package/1-input/index';
import { collection, getFirestore, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { writeJobPostingBothStores } from '../../jobPostingRef';
import DefaultSelect1 from '../../../../package/1-select/index';
import DefaultTextarea1 from '../../../../package/1-textarea/index';
import ErrorMessage from '../../../../package/error/index';
import { defaultEmployment17, defaultEmployment18, employmentData17, employmentData18, employmentData20, infoData, prfWage, ValidationError } from '../../../../../type';
import DefaultInput1Input1 from 'src/salon/package/1-input-1-input';
import DefaultInput2Overtime from 'src/salon/package/2-input-fixed';
import DefaultTrialConditions from 'src/salon/package/trialConditions';
import Hint from '../../../1.manual/3.school/2.edit/hint/index';
import DefaultDesc from 'src/salon/package/desc';
import { useAppSelector } from 'src/salon/app/hook';

type EmploymentProps = {
  graduateAge: number;
  companyId: string;
  year: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  info: infoData;
  employment17: employmentData17;
  setEmployment17: React.Dispatch<React.SetStateAction<employmentData17>>;
  employment18: employmentData18;
  setEmployment18: React.Dispatch<React.SetStateAction<employmentData18>>;
  employment20: employmentData20;
  setEmployment20: React.Dispatch<React.SetStateAction<employmentData20>>;
};

const SchoolEmployment20: React.FC<EmploymentProps> = ({ graduateAge, companyId, year, setChangeData, info, employment17, setEmployment17, employment18, setEmployment18, employment20, setEmployment20 }) => {

  const [ errorMessage, setErrorMessage ] = useState<ValidationError>(null);
  const [ banner, setBanner ] = useState<boolean>(false);
  const [ hintText, setHintText ] = useState<any>({ title: "", desc: "" });

  function validateData(data: employmentData20): { message: string; fieldId: string } | null {
    if (!data.type) return { message: '雇用形態を入力してください。', fieldId: 'type' };
    if (!data.workSystem) return { message: '労働制度を選択してください。', fieldId: 'workSystem' };

    // 1か月単位変形労働時間制のチェック
    if (data.workSystem === "1か月単位変形労働時間制") {
      if (!data.variableWork.hours28Days) return { message: '28日/月の労働時間を入力してください。', fieldId: 'hours28Days' };
      if (data.variableWork.hours28Days && !/^\d+$/.test(data.variableWork.hours28Days)) return { message: '28日/月の労働時間を数字で入力してください。', fieldId: 'hours28Days' };
      if (!data.variableWork.hours29Days) return { message: '29日/月の労働時間を入力してください。', fieldId: 'hours29Days' };
      if (data.variableWork.hours29Days && !/^\d+$/.test(data.variableWork.hours29Days)) return { message: '29日/月の労働時間を数字で入力してください。', fieldId: 'hours29Days' };
      if (!data.variableWork.hours30Days) return { message: '30日/月の労働時間を入力してください。', fieldId: 'hours30Days' };
      if (data.variableWork.hours30Days && !/^\d+$/.test(data.variableWork.hours30Days)) return { message: '30日/月の労働時間を数字で入力してください。', fieldId: 'hours30Days' };
      if (!data.variableWork.hours31Days) return { message: '31日/月の労働時間を入力してください。', fieldId: 'hours31Days' };
      if (data.variableWork.hours31Days && !/^\d+$/.test(data.variableWork.hours31Days)) return { message: '31日/月の労働時間を数字で入力してください。', fieldId: 'hours31Days' };
    }

    if (data.workSystem === "1年単位変形労働時間制") {
      if (!data.variableWork.hoursYearly) return { message: '1年の労働時間を入力してください。', fieldId: 'hoursYearly' };
      if (data.variableWork.hoursYearly && !/^\d+$/.test(data.variableWork.hoursYearly)) return { message: '1年の労働時間を数字で入力してください。', fieldId: 'hoursYearly' };
    }

    // 契約期間チェック
    if (data.contractPeriod.exist === null) return { message: '雇用期間の定めの有無を選択してください。', fieldId: 'contractPeriod.exist' };
    if (data.contractPeriod.exist && !data.contractPeriod.text) return { message: '雇用期間を入力してください。', fieldId: 'contractPeriod.text' };
    if (data.contractPeriod.exist && data.contractPeriod.text && !/^\d+$/.test(data.contractPeriod.text)) return { message: '雇用期間を数値で入力してください。', fieldId: 'contractPeriod.text' };

    // 試用期間チェック
    if (data.employmentTrial.exist === null) return { message: '試用期間の有無を選択してください。', fieldId: 'employmentTrial.exist' };
    if (data.employmentTrial.exist && !data.employmentTrial.text) return { message: '試用期間を入力してください。', fieldId: 'employmentTrial.text' };
    if (data.employmentTrial.exist && data.employmentTrial.text && !/^\d+$/.test(data.employmentTrial.text)) return { message: '試用期間を数値で入力してください。', fieldId: 'employmentTrial.text' };

    if (data.employmentTrial.exist && (data.employmentTrial.conditions === "" || data.employmentTrial.conditions === null)) return { message: '試用期間中の労働条件を入力してください。', fieldId: 'employmentTrial.conditions' };
    if (data.employmentTrial.conditions === "異なる" && !data.employmentTrial.trialWorkConditions) return { message: '試用期間中の労働条件の内容を入力してください。', fieldId: 'employmentTrial.trialWorkConditions' };

    // 賃金系
    if (data.salaryType === null || data.salaryType === "") return { message: '賃金形態を選択してください。', fieldId: 'salaryType' };
    if (data.salaryType === "月給" && !data.baseSalary) return { message: '基本給を入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "月給" && isNumeric(data.baseSalary)) return { message: '基本給を数値で入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "日給" && !data.dailyHours) return { message: '労働時間/日を入力してください。', fieldId: 'dailyHours' };
    if (data.salaryType === "日給" && isNumericAndDot(data.dailyHours)) return { message: '労働時間/日を数値で入力してください。', fieldId: 'dailyHours' };
    if (data.salaryType === "日給" && !data.baseSalary) return { message: '日給を入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "日給" && isNumeric(data.baseSalary)) return { message: '日給を数値で入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "時給" && !data.baseSalary) return { message: '時給を入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "時給" && isNumeric(data.baseSalary)) return { message: '時給を数値で入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "年俸制" && !data.baseSalary) return { message: '年俸制を入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "年俸制" && isNumeric(data.baseSalary)) return { message: '年俸制を数値で入力してください。', fieldId: 'baseSalary' };

    if (data.salaryType === "時給" && data.baseSalary.length !== 4) return { message: '時給を正しく入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "日給" && !(data.baseSalary.length === 5 || data.baseSalary.length === 4)) return { message: '日給を正しく入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "月給" && data.baseSalary.length !== 6) return { message: '月給を正しく入力してください。', fieldId: 'baseSalary' };
    if (data.salaryType === "年俸制" && data.baseSalary.length !== 7) return { message: '年俸制を正しく入力してください。', fieldId: 'baseSalary' };

    const allowances: Array<keyof typeof data.regularAllowance> = ['allowance1', 'allowance2'];

    for (let i = 0; i < allowances.length; i++) {
      const allowanceKey = allowances[i];
      const num = (i + 1).toString();
      const priceKey = `price${num}` as keyof typeof data.regularAllowance;

      const allowance = data.regularAllowance[allowanceKey];
      const price = data.regularAllowance[priceKey];

      if (allowance === "" && price !== "") { return { message: `手当て${num === "1" ? "①" : "②"}の文字を入力してください。`, fieldId: allowanceKey }; }
      if (allowance !== "" && price === "") { return { message: `手当て${num === "1" ? "①" : "②"}の金額を入力してください。`, fieldId: priceKey }; }
      if (price !== "" && isNumeric(price)) { return { message: `手当て${num === "1" ? "①" : "②"}の金額を数値で入力してください。`, fieldId: priceKey }; }
      if (isTrafficAllowanceName(allowance)) { return { message: '交通費は「福利厚生」欄にてご記入ください', fieldId: allowanceKey }; }
    }

    if ((data.salaryType === "年俸制" || data.salaryType === "月給") && data.workSystem !== "1年単位変形労働時間制" && !data.avgMonthlyHours) return { message: '平均労働時間/月を入力してください。', fieldId: 'avgMonthlyHours' };
    if ((data.salaryType === "年俸制" || data.salaryType === "月給") && data.workSystem !== "1年単位変形労働時間制" && isNumericAndDot(data.avgMonthlyHours)) return { message: '平均労働時間/月を数値で入力してください。', fieldId: 'avgMonthlyHours' };
    if (data.fixedOvertime.exist === null) return { message: '固定残業代の有無を選択してください。', fieldId: 'fixedOvertime.exist' };

    if (data.fixedOvertime.exist && !data.fixedOvertime.price) return { message: '固定残業代の範囲の金額を入力してください。', fieldId: 'fixedOvertime.price' };
    if (data.fixedOvertime.exist && isNumeric(data.fixedOvertime.price)) return { message: '固定残業代の範囲の時間を数値で入力してください。', fieldId: 'fixedOvertime.price' };
    if (data.fixedOvertime.exist && !data.fixedOvertime.time) return { message: '固定残業代の範囲の時間を入力してください。', fieldId: 'fixedOvertime.time' };
    if (data.fixedOvertime.exist && isNumericAndDot(data.fixedOvertime.time)) return { message: '固定残業代の範囲の時間を数値で入力してください。', fieldId: 'fixedOvertime.time' };

    if (!data.incentive) return { message: 'インセンティブを入力してください。', fieldId: 'incentive' };

    return null;
  }

  const company = useAppSelector((state) => state.company.company);

  const [ storesPlace, setStoresPlace ] = useState<string[]>([]);

  useEffect(() => {
    const db = getFirestore();

    const queryRef = query(
      collection(db, 'stores'),
      where('companyId', '==', company.id),
      orderBy('number', 'asc')
    );

    const unsub = onSnapshot(queryRef, (snapshot) => {
      const allPrefectures: string[] = [];

      snapshot.docs.forEach((doc) => {
        const data = doc.data();
        const tags: string[] = data.stationTags || [];
        const prefectures = tags.filter((tag) => /(都|道|府|県)$/.test(tag));
        allPrefectures.push(...prefectures);
      });

      setStoresPlace([...new Set(allPrefectures)]);

    });

    return () => unsub();
  }, []);

  function check() {
    setErrorMessage(null);
    window.scrollTo(0, 0);
    const error = validateData(employment);
    if (error) {
      setErrorMessage(error);

      const el = document.getElementById(error.fieldId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus?.();
      }

      return;
    }
    save(true);
  }

  const [ uploading, setUploading ] = useState(false);

  const save = async (isCompleted: boolean) => {
    try {
      const db = getFirestore();

      const payload = {
        ...employment,
        isCompleted,
        time: new Date(),
      };

      setUploading(true);

      const warnings = buildEmploymentWarnings(employment, info, storesPlace);

      await writeJobPostingBothStores(db, companyId, year, {
        [`employment${graduateAge}`]: payload,
        [`warning.employment${graduateAge}`]: warnings,
      });

      setChangeData(false);

    } catch (error) {
      console.error("保存エラー:", error);
      setUploading(false);
    } finally {
      setUploading(false);
      setBanner(true);
      setTimeout(() => { setBanner(false); }, 1500);
    }
  };

  const db = getFirestore();

  // 18歳
  async function handleSameTo20(targetAge: number) {
    await writeJobPostingBothStores(db, companyId, year, {
      [`employment${targetAge}`]: employment20,
      [`employment${targetAge}.isCompleted`]: false,
      [`employment${targetAge}.contents`]: "専門(20歳卒)の内容と同一",
    });
  }

  async function handleDifferentTo20(targetAge: number) {
    const defaultEmployment = targetAge === 18 ? defaultEmployment18 : defaultEmployment17;
    await writeJobPostingBothStores(db, companyId, year, {
      [`employment${targetAge}`]: defaultEmployment,
      [`employment${targetAge}.isCompleted`]: false,
      [`employment${targetAge}.contents`]: "専門(20歳卒)の内容と異なる",
    });
  }

  // copyEmployment(追加元の情報, 追加する側)}
  async function copyEmployment(fromAge: number, toAge: number) {
    const fromEmployment = fromAge === 20 ? employment20 : fromAge === 18 ? employment18 : employment17;
    await writeJobPostingBothStores(db, companyId, year, {
      [`employment${toAge}`]: fromEmployment,
      [`employment${toAge}.isCompleted`]: false,
      [`employment${toAge}.contents`]: "専門(20歳卒)の内容と異なる",
    });
  }

  // 上部に共通関数を用意
  const getEmploymentByAge = (age: number) => {
    if (age === 20) return employment20;
    if (age === 18) return employment18;
    return employment17;
  };
  const setEmploymentByAge = (age: number) => {
    if (age === 20) return setEmployment20;
    if (age === 18) return setEmployment18;
    return setEmployment17;
  };

  const employment = getEmploymentByAge(graduateAge);
  const setEmployment = setEmploymentByAge(graduateAge);


  const baseSalaryNum = Number(employment.baseSalary);

  const isNumeric = (str: string) => !!str && !/^[0-9]+$/.test(str);
  const isNumericAndDot = (str: string) => !!str && !/^[0-9.]+$/.test(str);
  const isTrafficAllowanceName = (str: string) => !!str && ['通勤', '交通', '移動', '電車'].some((k) => str.includes(k));


  // 都道府県ごとにチェック
  const belowWagePrefs = storesPlace
    .filter((pref) => {
      const minWage = prfWage[pref];
      return ( employment.salaryType === "時給" && !isNaN(baseSalaryNum) && minWage && baseSalaryNum < minWage );
    });

  return (
    <>
    {errorMessage && <ErrorMessage message={errorMessage.message} />}
    {banner && <div className={Styles.banner}>保存しました。</div>}
    {hintText.title !== "" && ( <Hint contents={hintText} setHintText={setHintText} /> )}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>雇用条件</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => check()}>保存</button>
      </div>
    </div>

    {graduateAge !== 20 && (
    <>
      <div id="contents" tabIndex={-1}></div>
      <div className={Styles.test_box}>
        <DefaultSelect1
          error={false}
          title={'求人内容'}
          list={['未選択', '専門(20歳卒)の内容と同一', '専門(20歳卒)の内容と異なる']} desc={''}
          value={employment.contents}
          setValue={(val: string) => {
            setEmployment(prev => ({ ...prev, contents: val }));
            setChangeData(true);

            if (val === '専門(20歳卒)の内容と同一') {
              handleSameTo20(graduateAge);
            } else if (val === '専門(20歳卒)の内容と異なる') {
              handleDifferentTo20(graduateAge);
            }
          }} />
      </div>
    </>
    )}

    {graduateAge !== 20 && (
      <div className={Styles.recruit_copy}>
        {graduateAge !== 20 && (
          <button onClick={() => copyEmployment(20, graduateAge)}>20歳の求人情報をコピー</button>
        )}
        {graduateAge === 18 && (
          <button onClick={() => copyEmployment(17, 18)}>17歳の求人情報をコピー</button>
        )}
        {graduateAge === 17 && (
          <button onClick={() => copyEmployment(18, 17)}>18歳の求人情報をコピー</button>
        )}
      </div>
    )}

    <div id="type" tabIndex={-1}></div>
    <div className={Styles.test_box}>
      <DefaultSelect1
        error={errorMessage?.fieldId === "type"}
        title={'雇用形態'} desc={''}
        list={['未選択', '正社員', '契約社員', '業務委託']}
        value={employment.type}
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, type: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

    </div>

    <div className={Styles.test_box}>

      <div id="workSystem" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "workSystem"}
        title={'労働制度'}
        list={[ "未選択", "所定労働時間制", "フレックスタイム制", "シフト制", "1か月単位変形労働時間制", "1年単位変形労働時間制" ]} desc={''}
        value={ employment.workSystem }
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, workSystem: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      {employment.workSystem === "1か月単位変形労働時間制" && (
      <>
        <div id="variableWork" tabIndex={-1}></div>
        <DefaultTrialConditions
          error1={errorMessage?.fieldId === "hours28Days"}
          error2={errorMessage?.fieldId === "hours29Days"}
          error3={errorMessage?.fieldId === "hours30Days"}
          error4={errorMessage?.fieldId === "hours31Days"}
          error5={false}
          period="月" title="労働時間" value1={employment.variableWork} place1="" length={5} desc=""
          setValue1={(val) => {
            setEmployment((prev: any) => ({ ...prev, variableWork: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />

        {/* 数値チェック */}
        <DefaultDesc text={"※28日の労働時間を半角数字で入力してください。"} type={"error"} error={isNumeric(employment.variableWork.hours28Days)} />
        <DefaultDesc text={"※29日の労働時間を半角数字で入力してください。"} type={"error"} error={isNumeric(employment.variableWork.hours29Days)} />
        <DefaultDesc text={"※30日の労働時間を半角数字で入力してください。"} type={"error"} error={isNumeric(employment.variableWork.hours30Days)} />
        <DefaultDesc text={"※31日の労働時間を半角数字で入力してください。"} type={"error"} error={isNumeric(employment.variableWork.hours31Days)} />

        <div style={{ height: "5px" }}></div>

        {/* 28日 */}
        {(employment.variableWork.hours28Days !== "" && !info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の28日/月の場合、160時間が上限として定められています。"} type={"warning"} error={160 < Number(employment.variableWork.hours28Days)} />
        )}
        {(employment.variableWork.hours28Days && info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の28日/月の場合、176時間（特例措置対象事業所を加味）が上限として定められています。"} type={"warning"} error={176 < Number(employment.variableWork.hours28Days)} />
        )}

        {/* 29日 */}
        {(employment.variableWork.hours29Days && !info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の29日/月の場合、165.7時間が上限として定められています。"} type={"warning"} error={165.7 < Number(employment.variableWork.hours29Days)} />
        )}
        {(employment.variableWork.hours29Days && info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の29日/月の場合、182.2時間（特例措置対象事業所を加味）が上限として定められています。"} type={"warning"} error={182.2 < Number(employment.variableWork.hours29Days)} />
        )}

        {/* 30日 */}
        {(employment.variableWork.hours30Days && !info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の30日/月の場合、171.4時間が上限として定められています。"} type={"warning"} error={171.4 < Number(employment.variableWork.hours30Days)} />
        )}
        {(employment.variableWork.hours30Days && info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の30日/月の場合、188.5時間（特例措置対象事業所を加味）が上限として定められています。"} type={"warning"} error={188.5 < Number(employment.variableWork.hours30Days)} />
        )}

        {/* 31日 */}
        {(employment.variableWork.hours31Days && !info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の31日/月の場合、177.1時間が上限として定められています。"} type={"warning"} error={177.1 < Number(employment.variableWork.hours31Days)} />
        )}
        {(employment.variableWork.hours31Days && info.isSpecialExemption) && (
          <DefaultDesc text={"※警告：1か月単位変形労働時間制の31日/月の場合、194.8時間（特例措置対象事業所を加味）が上限として定められています。"} type={"warning"} error={194.8 < Number(employment.variableWork.hours31Days)} />
        )}

      </> )}

      {employment.workSystem === "1年単位変形労働時間制" && (
      <>
        <div id="variableWork" tabIndex={-1}></div>
        <DefaultTrialConditions
          error1={false}
          error2={false} error3={false} error4={false}
          error5={errorMessage?.fieldId === "hoursYearly"}
          period="年" title="労働時間" value1={employment.variableWork} desc="" place1="" length={5}
          setValue1={(val) => {
            setEmployment((prev: any) => ({ ...prev, variableWork: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />

        {/* 数値チェック */}
        <DefaultDesc text={"※半角数字のみで入力してください。"} type={"error"} error={isNumeric(employment.variableWork.hoursYearly)} />

        {/* 1年 */}
        {(Number(employment.variableWork.hoursYearly) > 2085) && (
          <DefaultDesc text={"※警告：1年間の法定労働時間上限は2,085時間です。"} type={"warning"} error={true} />
        )}

      </> )}

    </div>

    <div className={Styles.test_box}>

      <div id="contractPeriod.exist" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "contractPeriod.exist"}
        title={'雇用期間の定めの有無'} list={[ '未選択', '雇用期間の定め有り', '雇用期間の定め無し' ]} desc={''}
        value={ employment.contractPeriod.exist === null ? '未選択' : employment.contractPeriod.exist ? '雇用期間の定め有り' : '雇用期間の定め無し' }
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, contractPeriod: { ...prev.contractPeriod, exist: val === '雇用期間の定め有り' ? true : val === '雇用期間の定め無し' ? false : null }, }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      {employment.contractPeriod.exist === true && (
      <>
        <div id="contractPeriod.text" tabIndex={-1}></div>
        <DefaultInput1
          error={errorMessage?.fieldId === "contractPeriod.text"}
          title={'雇用期間（ヶ月）'} length={2} place={'6'} desc={''}
          value={employment.contractPeriod.text || ''}
          setValue={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, contractPeriod: { ...prev.contractPeriod, text: val, }, }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
      </> )}

      <DefaultDesc text={"※雇用期間の月数を半角数字で入力してください。"} type={"error"} error={isNumeric(employment.contractPeriod.text)} />

    </div>

    <div className={Styles.test_box}>

      <div id="employmentTrial.exist" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "employmentTrial.exist"}
        title={'試用期間の有無'} list={[ '未選択', '試用期間有り', '試用期間無し' ]}
        value={ employment.employmentTrial.exist === null ? '未選択' : employment.employmentTrial.exist ? '試用期間有り' : '試用期間無し' }
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, employmentTrial: { ...prev.employmentTrial, exist: val === '試用期間有り' ? true : val === '試用期間無し' ? false : null }, }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      {employment.employmentTrial.exist === true && (
      <>
        <div id="employmentTrial.text" tabIndex={-1}></div>
        <DefaultInput1
          error={errorMessage?.fieldId === "employmentTrial.text"}
          title={'試用期間（ヶ月） ※'} length={2} place={'6'} desc={''}
          value={employment.employmentTrial.text || ''}
          setValue={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, employmentTrial: { ...prev.employmentTrial, text: val, }, }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
        <DefaultDesc text={"※試用期間の月数を半角数字で入力してください。"} type={"error"} error={isNumeric(employment.employmentTrial.text)} />
      </> )}

      {employment.employmentTrial.exist === true && (
      <>
        <div id="employmentTrial.conditions" tabIndex={-1}></div>
        <DefaultSelect1
          error={errorMessage?.fieldId === "employmentTrial.conditions"} title="試用期間中の労働条件" list={['未選択', '同条件', '異なる']} desc=""
          value={employment.employmentTrial.conditions ?? '未選択'}
          setValue={(val: string) => {
            setEmployment(prev => ({ ...prev, employmentTrial: { ...prev.employmentTrial, conditions: val === '未選択' ? null : val, }, }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
      </> )}

      {employment.employmentTrial.conditions === "異なる" && (
      <>
        <div id="employmentTrial.trialWorkConditions" tabIndex={-1}></div>
        <DefaultTextarea1 title={'試用期間中の労働条件の内容'} length={100} place={''}
          error={errorMessage?.fieldId === "employmentTrial.trialWorkConditions"}
          value={employment.employmentTrial.trialWorkConditions}
          setValue={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, employmentTrial: { ...prev.employmentTrial, trialWorkConditions: val }}));
            setChangeData(true);
            setErrorMessage(null);
          }} />

        <DefaultDesc text={"※求人票には記載されず、学校、及び生徒にのみ表示されます。"} />
      </> )}

    </div>

    <div className={Styles.test_box}>

      <div id="salaryType" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "salaryType"}
        title={'賃金形態'} list={[ "未選択", "月給", "日給", "時給", "年俸制", ]}
        value={employment.salaryType ?? "未選択"}
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, salaryType: val === "未選択" ? null : val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      {((employment.salaryType === "年俸制" || employment.salaryType === "月給") && employment.workSystem !== "1年単位変形労働時間制") && (
      <>
        <div id="avgMonthlyHours" tabIndex={-1}></div>
        <DefaultInput1
          error={errorMessage?.fieldId === "avgMonthlyHours"}
          title={'平均労働時間/月'} length={5} place={'220'}
          value={employment.avgMonthlyHours || ''}
          setValue={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, avgMonthlyHours: val }));
            setChangeData(true);
            setErrorMessage(null);
          }}
          desc={'※就業時間は、固定残業代に含まれる時間・時間外労働時間を除いて入力してください。'}
          hint={{title: "平均就業時間の算出方法", desc: "この項目は、地域ごとの最低賃金を下回っていないかを確認するために使用されます。<br />求人票のプレビューには反映されません。<br /><strong>最低賃金の計算式：</strong><br />（給与（月当たり）＋定額手当）÷就業時間<br />比較対象：店舗が登録されている全ての都道府県の最低賃金"}}
          setHintText={setHintText} />

        <DefaultDesc text={"※休憩時間を除いて入力してください"}/>
        <DefaultDesc text={"※半角数字（小数点含む）のみで入力してください。"} type={"error"} error={isNumericAndDot(employment.avgMonthlyHours)} />
        {!info.isSpecialExemption && Number(employment.avgMonthlyHours) > 177 && (
          <DefaultDesc text={"※警告：1ヶ月の法定労働時間上限は177時間です"} type={"warning"} error={true} />
        )}
        {info.isSpecialExemption && Number(employment.avgMonthlyHours) > 194 && (
          <DefaultDesc text={"※警告：1ヶ月の法定労働時間上限は194時間です。"} type={"warning"} error={true} />
        )}
      </> )}

      {employment.salaryType === "日給" && (
      <>
        <div id="dailyHours" tabIndex={-1}></div>
        <DefaultInput1
          error={errorMessage?.fieldId === "dailyHours"}
          title={'労働時間/日'} length={3} place={'6'}
          value={employment.dailyHours || ''}
          setValue={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, dailyHours: val, }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
        <DefaultDesc text={"※休憩時間は加味せずに入力してください。"}/>
        <DefaultDesc text={"※半角数字（小数点含む）のみで入力してください。"} type={"error"} error={isNumericAndDot(employment.dailyHours)} />
      </> )}

      <div id="baseSalary" tabIndex={-1}></div>
      <DefaultInput1
        error={errorMessage?.fieldId === "baseSalary"}
        title={employment.salaryType !== null ? employment.salaryType : "給与"} length={employment.salaryType === "年俸制" ? 7 : employment.salaryType === "月給" ? 6 : employment.salaryType === "日給" ? 5 : 4} place={'220000'} desc={''}
        value={employment.baseSalary}
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, baseSalary: val }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        hint={{title: "", desc: ""}} setHintText={setHintText} />
      <DefaultDesc text={"※半角数字のみで入力してください。"} type={"error"} error={isNumeric(employment.baseSalary)} />

      {/* 給与文字数 */}
      {employment.salaryType === "時給" && (
        <DefaultDesc text={`※時給の給与を正しく入力してください。`} type={"error"} error={employment.baseSalary.length !== 4} />
      )}
      {employment.salaryType === "日給" && (
        <DefaultDesc text={`※日給の給与を正しく入力してください。`} type={"error"} error={!(employment.baseSalary.length === 4 || employment.baseSalary.length === 5)} />
      )}
      {employment.salaryType === "月給" && (
        <DefaultDesc text={`※月給の給与を正しく入力してください。`} type={"error"} error={employment.baseSalary.length !== 6} />
      )}
      {employment.salaryType === "年俸制" && (
        <DefaultDesc text={`※年俸制の給与を正しく入力してください。`} type={"error"} error={employment.baseSalary.length !== 7} />
      )}

      <div
        className={Styles.desc}
        style={storesPlace.some((pref) => employment.salaryType === "時給" && !isNaN(Number(employment.baseSalary)) && prfWage[pref] && Number(employment.baseSalary) < prfWage[pref]) ? { color: "#F2941A", fontWeight: "bold" } : {}}>
        {storesPlace
          .filter((pref) => employment.salaryType === "時給" && !isNaN(Number(employment.baseSalary)) && prfWage[pref] && Number(employment.baseSalary) < prfWage[pref])
          .map((pref) => (
            <div key={pref}>
              ※警告：{pref}の最低賃金は{prfWage[pref]}円と定められています。
            </div>
          ))}
      </div>

      {employment.salaryType === "日給" && employment.dailyHours && /^\d+$/.test(employment.dailyHours) && !isNaN(Number(employment.baseSalary)) && (
        <div className={Styles.desc} style={
          storesPlace.some(pref => Number(employment.baseSalary)/Number(employment.dailyHours) < prfWage[pref]) ? { color: "#F2941A", fontWeight: "bold" } : {} }>
          {storesPlace
            .filter(pref => Number(employment.baseSalary)/Number(employment.dailyHours) < prfWage[pref])
            .map(pref => (
              <div key={pref}>
                ※警告：{pref}の最低賃金は{prfWage[pref]}円と定められています。
              </div>
            ))}
        </div>
      )}

      {(employment.salaryType === "年俸制" || employment.salaryType === "月給") && (
      <>
        <div id="regularAllowance.allowance1" tabIndex={-1}></div>
        <DefaultInput1Input1
          title={'定額的に支給される手当て ①'} length={15} place1={'地域手当'} place2={'20000'} desc={'※本項目には、毎月全スタッフに支払う手当を記載してください。\n（こちらに該当しない手当は「8.福利厚生」にてご記載ください。）'}
          value1={employment.regularAllowance.allowance1 || ''}
          setValue1={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, regularAllowance: { ...prev.regularAllowance, allowance1: val, }, }));
            setChangeData(true);
            setErrorMessage(null);
          }}
          value2={employment.regularAllowance.price1 || ''}
          setValue2={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, regularAllowance: { ...prev.regularAllowance, price1: val, }, }));
            setChangeData(true);
            setErrorMessage(null);
          }} />

        <DefaultDesc text={"※金額は半角数字のみで入力してください。"} type={"error"} error={isNumeric(employment.regularAllowance.price1)} />
        {employment.salaryType === "年俸制" && (
          <DefaultDesc text={"※金額は、1ヶ月分に換算してご記載ください"} type={"error"} error={isNumeric(employment.regularAllowance.price1)} />
        )}
        <DefaultDesc text={"※交通費は「福利厚生」欄にてご記入ください"} type={"error"} error={isTrafficAllowanceName(employment.regularAllowance.allowance1)} />
      </> )}

      {(employment.salaryType === "年俸制" || employment.salaryType === "月給") && (
      <>
        <div id="regularAllowance.allowance2" tabIndex={-1}></div>
        <DefaultInput1Input1
          title={'定額的に支給される手当て ②'} length={15} place1={'地域手当'} place2={'20000'} desc={''}
          value1={employment.regularAllowance.allowance2 || ''}
          setValue1={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, regularAllowance: { ...prev.regularAllowance, allowance2: val, }, }));
            setChangeData(true);
            setErrorMessage(null);
          }}
          value2={employment.regularAllowance.price2 || ''}
          setValue2={(val: string) => {
            setEmployment((prev: any) => ({ ...prev, regularAllowance: { ...prev.regularAllowance, price2: val, }, }));
            setChangeData(true);
            setErrorMessage(null);
          }} />

        <DefaultDesc text={"※金額は半角数字のみで入力してください。"} type={"error"} error={isNumeric(employment.regularAllowance.price2)} />
        {employment.salaryType === "年俸制" && (
          <DefaultDesc text={"※金額は、1ヶ月分に換算してご記載ください"} type={"error"} error={isNumeric(employment.regularAllowance.price1)} />
        )}
        <DefaultDesc text={"※交通費は「福利厚生」欄にてご記入ください"} type={"error"} error={isTrafficAllowanceName(employment.regularAllowance.allowance2)} />
      </> )}

      {(employment.salaryType === "年俸制" || employment.salaryType === "月給") && (
        <div className={Styles.desc}
          style={storesPlace.some((pref) => {
            const totalSalary = (employment.salaryType === "年俸制" ? Number(employment.baseSalary) / 12 : Number(employment.baseSalary)) + (Number(employment.regularAllowance.price1) || 0) + (Number(employment.regularAllowance.price2) || 0);
            const monthlyHours = employment.workSystem === "1年単位変形労働時間制"
              ? Number(employment.variableWork?.hoursYearly) / 12
              : Number(employment.avgMonthlyHours);
            if (!monthlyHours) return false;
            const hourlyWage = totalSalary / monthlyHours;
            return prfWage[pref] && hourlyWage < prfWage[pref];
          }) ? { color: "#F2941A", fontWeight: "bold" } : {}}>
          {storesPlace
            .filter((pref) => {
              const totalSalary =
                (employment.salaryType === "年俸制" ? Number(employment.baseSalary) / 12 : Number(employment.baseSalary)) +
                (Number(employment.regularAllowance.price1) || 0) +
                (Number(employment.regularAllowance.price2) || 0);
              const monthlyHours = employment.workSystem === "1年単位変形労働時間制"
                ? Number(employment.variableWork?.hoursYearly) / 12
                : Number(employment.avgMonthlyHours);
              if (!monthlyHours) return false;
              const hourlyWage = totalSalary / monthlyHours;
              return prfWage[pref] && hourlyWage < prfWage[pref];
            })
            .map((pref) => (
              <div key={pref}>
                ※警告：{pref}の最低賃金は{prfWage[pref]}円と定められています。
              </div>
            ))}
        </div>
      )}

    </div>

    <div className={Styles.test_box}>

      <div id="fixedOvertime.exist" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "fixedOvertime.exist"}
        title={'固定残業代の有無'} list={[ "未選択", '固定残業代有り', "固定残業代無し" ]}
        value={ employment.fixedOvertime.exist === null ? '未選択' : employment.fixedOvertime.exist ? '固定残業代有り' : '固定残業代無し' }
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, fixedOvertime: { ...prev.fixedOvertime, exist: val === '固定残業代有り' ? true : val === '固定残業代無し' ? false : null }, }));
          setChangeData(true);
          setErrorMessage(null);
          setEmployment((prev: any) => ({ ...prev, fixedOvertime: { ...prev.fixedOvertime, price: "" }, }));
          setEmployment((prev: any) => ({ ...prev, fixedOvertime: { ...prev.fixedOvertime, time: "" }, }));
        }}/>

      <DefaultDesc text={"※警告：法定労働時間外の業務には、原則36協定の締結が必要になります。"} type={"warning"} error={!Boolean(info.exist36Agreement) && Boolean(employment.fixedOvertime.exist)} />

      {employment.fixedOvertime.exist && (
      <>
        <div id="fixedOvertime.time" tabIndex={-1}></div>
        <div id="fixedOvertime.price" tabIndex={-1}></div>
        <DefaultInput2Overtime
          title={'固定残業代の範囲'}
          error1={errorMessage?.fieldId === "fixedOvertime.price"}
          value1={employment.fixedOvertime.price || ""}
          setValue1={(val) => {
            setEmployment((prev: any) => ({ ...prev, fixedOvertime: { ...prev.fixedOvertime, price: val }, }));
            setErrorMessage(null);
          }}
          error2={errorMessage?.fieldId === "fixedOvertime.time"}
          value2={employment.fixedOvertime.time || ""}
          setValue2={(val) => {
            setEmployment((prev: any) => ({ ...prev, fixedOvertime: { ...prev.fixedOvertime, time: val }, }));
            setErrorMessage(null);
          }}
          unit={''}
        />
        <DefaultDesc text={"※超過分は全額支給する旨が求人票には記載されます。"} />
        <DefaultDesc text={"※金額を半角数字で入力してください。"} type={"error"} error={Boolean(employment.fixedOvertime.price) && !/^\d+$/.test(employment.fixedOvertime.price)} />
        <DefaultDesc text={"※時間を半角数字で入力してください。"} type={"error"} error={Boolean(employment.fixedOvertime.time) && isNumericAndDot(employment.fixedOvertime.time)} />
        {/* <p className={Styles.desc} style={employment.fixedOvertime.time && !/^\d+$/.test(employment.fixedOvertime.time) ? { color: "#E31C5F", fontWeight: "bold" } : {}}>※時間を半角数字で入力してください。</p> */}
      </> )}

      <div className={Styles.desc}>
        {/* 通常時給の1.25倍チェック（1回だけ） */}
        {(() => {
          const normalHourly = computeNormalHourly(employment);
          const fixedPrice = Number(employment.fixedOvertime.price);
          const fixedTime = Number(employment.fixedOvertime.time);
          if (normalHourly && fixedPrice && fixedTime) {
            const fixedHourly = fixedPrice / fixedTime;
            if (fixedHourly < normalHourly * 1.25) {
              return <div style={{ color: "#F2941A", fontWeight: "bold" }}>
                ※警告：固定残業代は通常時給の1.25倍以上になっていません（入力：{fixedHourly.toFixed(1)}円 {"<"} 規定：{(normalHourly * 1.25).toFixed(1)}円）
              </div>;
            }
          }
          return null;
        })()}

        {/* 最低賃金×1.25チェック（都道府県ごと） */}
        {storesPlace.map(pref => {
          const minWage = prfWage[pref];
          const fixedPrice = Number(employment.fixedOvertime.price);
          const fixedTime = Number(employment.fixedOvertime.time);
          if (minWage && fixedPrice && fixedTime) {
            const fixedHourly = fixedPrice / fixedTime;
            const minOvertime = minWage * 1.25;
            if (fixedHourly < minOvertime) {
              return <div key={pref} style={{ color: "#F2941A", fontWeight: "bold" }}>
                ※警告：固定残業代は{pref}最低賃金の1.25倍以上になっていません（入力：{fixedHourly.toFixed(1)}円 {"<"} 規定：{minOvertime.toFixed(1)}円）
              </div>;
            }
          }
          return null;
        })}
      </div>

    </div>

    <div className={Styles.test_box}>
      <div id="incentive" tabIndex={-1}></div>
      <DefaultTextarea1
        error={errorMessage?.fieldId === "incentive"}
        title="インセンティブ" length={90} place={''} desc=""
        value={employment.incentive}
        setValue={(val: string) => {
          setEmployment((prev: any) => ({ ...prev, incentive: val })); setChangeData(true);
          setErrorMessage(null);
        }}
        hint={{title: "インセンティブの記載方法", desc: "新卒に発生するインセンティブを記載していただく項目ですので、実際の発生要因を簡潔にご記載くださいませ。<br /><br /><strong>インセンティブ 記載例）</strong><br />・パターン1<br />指名：10％ 支給<br />店販：5％ 別途支給<br />技術や接客力を給与へ反映する仕組みです。<br />・パターン2<br />指名：5〜15％ 支給<br />店販：5％ 別途支給<br />売上や成長に応じて支給率がアップします。<br />・パターン3<br />指名：10％ 支給<br />店販：5％ 別途支給<br />紹介やSNS発信などの実績も評価対象です。"}} setHintText={setHintText} />

    </div>
  </>
  );
}

export default SchoolEmployment20;

// 給与形態に応じた通常時給を計算
export function computeNormalHourly(emp: any): number {
  const base = Number(emp?.baseSalary);
  if (!base) return 0;

  if (emp.salaryType === "時給") {
    return base;
  }
  if (emp.salaryType === "日給") {
    const hours = Number(emp.dailyHours);
    return hours ? base / hours : 0;
  }
  if (emp.salaryType === "月給") {
    const monthlyHours = emp.workSystem === "1年単位変形労働時間制"
      ? Number(emp.variableWork?.hoursYearly) / 12
      : Number(emp.avgMonthlyHours);
    return monthlyHours ? base / monthlyHours : 0;
  }
  if (emp.salaryType === "年俸制") {
    const monthlyHours = emp.workSystem === "1年単位変形労働時間制"
      ? Number(emp.variableWork?.hoursYearly) / 12
      : Number(emp.avgMonthlyHours);
    return monthlyHours ? (base / 12) / monthlyHours : 0;
  }
  return 0;
}

export function buildEmploymentWarnings(emp: any, info: any, storePlaces: string[]) {
  const isSpecialExemption = Boolean(info?.isSpecialExemption);
  const workSystem = emp?.workSystem ?? "";
  const vw = emp?.variableWork ?? {};

  const variableWork28 = workSystem === "1か月単位変形労働時間制" && !!vw.hours28Days && !isSpecialExemption && 160 < Number(vw.hours28Days);
  const variableWork28Special = workSystem === "1か月単位変形労働時間制" && !!vw.hours28Days && isSpecialExemption && 176 < Number(vw.hours28Days);
  const variableWork29 = workSystem === "1か月単位変形労働時間制" && !!vw.hours29Days && !isSpecialExemption && 165.7 < Number(vw.hours29Days);
  const variableWork29Special = workSystem === "1か月単位変形労働時間制" && !!vw.hours29Days && isSpecialExemption && 182.2 < Number(vw.hours29Days);
  const variableWork30 = workSystem === "1か月単位変形労働時間制" && !!vw.hours30Days && !isSpecialExemption && 171.4 < Number(vw.hours30Days);
  const variableWork30Special = workSystem === "1か月単位変形労働時間制" && !!vw.hours30Days && isSpecialExemption && 188.5 < Number(vw.hours30Days);
  const variableWork31 = workSystem === "1か月単位変形労働時間制" && !!vw.hours31Days && !isSpecialExemption && 177.1 < Number(vw.hours31Days);
  const variableWork31Special = workSystem === "1か月単位変形労働時間制" && !!vw.hours31Days && isSpecialExemption && 194.8 < Number(vw.hours31Days);

  const yearlyHours2085 = workSystem === "1年単位変形労働時間制" && Number(vw.hoursYearly) > 2085;

  const isNonVariableWorkSystem = workSystem !== "1か月単位変形労働時間制" && workSystem !== "1年単位変形労働時間制";
  const isMonthlyOrAnnual = emp?.salaryType === "月給" || emp?.salaryType === "年俸制";
  const monthlyHours177 = isNonVariableWorkSystem && isMonthlyOrAnnual && !isSpecialExemption && Number(emp?.avgMonthlyHours) > 177;
  const monthlyHours194 = isNonVariableWorkSystem && isMonthlyOrAnnual && isSpecialExemption && Number(emp?.avgMonthlyHours) > 194;

  const agreement36 = !Boolean(info?.exist36Agreement) && Boolean(emp?.fixedOvertime?.exist);

  const minWage = storePlaces.some((pref) => {
    const minW = prfWage[pref];
    if (!minW) return false;
    const salaryType = emp?.salaryType;
    if (salaryType === "時給") {
      return !isNaN(Number(emp.baseSalary)) && Number(emp.baseSalary) < minW;
    }
    if (salaryType === "日給") {
      const hours = Number(emp.dailyHours);
      if (!hours) return false;
      return Number(emp.baseSalary) / hours < minW;
    }
    if (salaryType === "月給" || salaryType === "年俸制") {
      const base = salaryType === "年俸制" ? Number(emp.baseSalary) / 12 : Number(emp.baseSalary);
      const total = base + (Number(emp.regularAllowance?.price1) || 0) + (Number(emp.regularAllowance?.price2) || 0);
      const monthlyHours = workSystem === "1年単位変形労働時間制"
        ? Number(emp.variableWork?.hoursYearly) / 12
        : Number(emp.avgMonthlyHours);
      if (!monthlyHours) {
        return false;
      }
      const hourlyWage = total / monthlyHours;
      return hourlyWage < minW;
    }
    return false;
  });

  const fixedOvertimeRate = (() => {
    const normalHourly = computeNormalHourly(emp);
    const fixedPrice = Number(emp?.fixedOvertime?.price);
    const fixedTime = Number(emp?.fixedOvertime?.time);
    if (!normalHourly || !fixedPrice || !fixedTime) return false;
    return (fixedPrice / fixedTime) < normalHourly * 1.25;
  })();

  const fixedOvertimeMinWage = storePlaces.some((pref) => {
    const minW = prfWage[pref];
    const fixedPrice = Number(emp?.fixedOvertime?.price);
    const fixedTime = Number(emp?.fixedOvertime?.time);
    if (!minW || !fixedPrice || !fixedTime) return false;
    return (fixedPrice / fixedTime) < minW * 1.25;
  });

  return {
    variableWork28,
    variableWork28Special,
    variableWork29,
    variableWork29Special,
    variableWork30,
    variableWork30Special,
    variableWork31,
    variableWork31Special,
    yearlyHours2085,
    monthlyHours177,
    monthlyHours194,
    agreement36,
    minWage,
    fixedOvertimeRate,
    fixedOvertimeMinWage,
  };
}

export const defaultEmploymentWarning = {
  variableWork28: false,
  variableWork28Special: false,
  variableWork29: false,
  variableWork29Special: false,
  variableWork30: false,
  variableWork30Special: false,
  variableWork31: false,
  variableWork31Special: false,
  yearlyHours2085: false,
  monthlyHours177: false,
  monthlyHours194: false,
  agreement36: false,
  minWage: false,
  fixedOvertimeRate: false,
  fixedOvertimeMinWage: false,
};
